/**
 * Valida o preset fornecido com base no isEnabled.
 *
 * @param {Object} preset - O preset que será validado.
 * @param {Object} state - O estado atual da store.
 * @param {Object} getters - Os getters da store.
 * @returns {boolean} Retorna `true` se o preset for válido, caso contrário, `false`.
 */
function isPresetEnabled(preset, state, getters) {
  switch (typeof preset.isEnabled) {
    case 'boolean':
      return preset.isEnabled;
    case 'function':
      return preset.isEnabled({
        ...state,
        ...getters,
      });
    default:
      return true;
  }
}

export default isPresetEnabled;
